module.exports = __webpack_public_path__ + "img/Free-Hair-Curls-Long-Curly-Hair-Topper-I.e5a1e605.jpg";